import { useContext } from 'react';
import { CollectionMethodChartsDataContext } from '../contexts/CollectionMethodChartsDataContext';

export const useCollectionMethodChartsDataContext = () => {
    return useContext(CollectionMethodChartsDataContext);
};
